import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { unarchiveCreative } from 'scenes/Gallery/GalleryPage/Creatives/sources/creatives';
import CustomBodyText from 'scenes/Gallery/components/CustomBodyText';

import { unarchive } from '../queryKeyFactory';

export const useUnarchive = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const mutation = useMutation(unarchive(), unarchiveCreative, {
    successMessage: () => 'Creative was unarchived',
  });

  const handleAction = async ({ id, name }) => {
    await showModal({
      title: 'Unarchive Creative?',
      confirmActionLabel: 'Unarchive',
      bodyText: <CustomBodyText name={name} />,
    });
    await mutation.mutateAsync({ ids: [id] });
  };

  return [handleAction, mutation];
};
